export const withCacheBuster = (url: string | undefined) => {
  if (!url || url.includes('X-Amz-Signature')) {
    return url;
  }

  return url.includes('?') ? `${url}&v2` : `${url}?v2`;
};

export const getThumbnailUrl = (
  imageUrl: string | undefined,
): string | undefined => {
  if (imageUrl?.includes('thumb_')) {
    return imageUrl;
  }
  if (imageUrl?.includes('https://assets.rocketlane.com/')) {
    return imageUrl;
  }
  /**
   * We are going to display the thumbnail instead of teh actual pic in the avatar
   * This is done temporarily on the FE; need to get thumbURL from the BE
   * Need to generally apply this for other avatars like project/company etc
   */
  const imgUrlSplit = imageUrl?.split('/');

  if (imgUrlSplit) {
    imgUrlSplit[imgUrlSplit.length - 1] = `thumb_${
      imgUrlSplit[imgUrlSplit.length - 1]
    }`;
  }
  const thumbUrl = imgUrlSplit?.join('/');

  return thumbUrl;
};
